import React from 'react';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import './Services.css';

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      path: '/web-development',
      title: t('services.webDev.title'),
      description: t('services.webDev.desc')
    },
    {
      path: '/custom-software',
      title: t('services.customSoft.title'),
      description: t('services.customSoft.desc')
    },
    {
      path: '/cloud-infrastructure',
      title: t('services.cloud.title'),
      description: t('services.cloud.desc')
    },
    {
      path: '/tech-consulting',
      title: t('services.consulting.title'),
      description: t('services.consulting.desc')
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-header fade-in-up">
          <span className="eyebrow">~/usluge</span>
          <h2>{t('services.title')}</h2>
        </div>

        <div className="services-list">
          {services.map((service, index) => (
            <Link
              key={index}
              to="contact"
              smooth={true}
              duration={600}
              offset={-80}
              className="service-row fade-in-up"
            >
              <span className="service-path">{service.path}</span>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <span className="service-arrow" aria-hidden="true">→</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
